import { contact } from './siteContent';

export const parentCompany = {
  name: '5INCH VENTURES PRIVATE LIMITED',
  shortName: '5INCH VENTURES',
  tagline: 'FastWhistle is a product of 5INCH VENTURES PRIVATE LIMITED',
  description:
    'FastWhistle builds pharma logistics and fleet management software for medicine distributors across India. The platform is developed and operated by 5INCH VENTURES PRIVATE LIMITED.',
};

export const officeLocations = [
  {
    id: 'fastwhistle-office',
    label: 'FastWhistle Office',
    badge: 'Product & Operations',
    brand: 'FastWhistle',
    address:
      '220, 3rd Floor, Highfield Ascot, VIP Rd, opp. Palm Avenue, Vesu, Surat, Gujarat 395007',
    city: 'Surat',
    state: 'Gujarat',
    postalCode: '395007',
    country: 'India',
    lat: 21.141491370128097,
    lng: 72.78031196888482,
    mapQuery: 'FastWhistle, Highfield Ascot, VIP Road, Vesu, Surat',
  },
  {
    id: 'head-office',
    label: 'Registered Head Office',
    badge: 'Parent Company',
    brand: parentCompany.name,
    address:
      'A/202, Bella Casa Apartment, Althan Canal Road, Althan, Surat, Gujarat 395017, India',
    city: 'Surat',
    state: 'Gujarat',
    postalCode: '395017',
    country: 'India',
    lat: 21.13282246797311,
    lng: 72.8044340170916,
    mapQuery: 'Bella Casa Apartment, Althan Canal Road, Althan, Surat',
  },
];

export function mapsEmbedUrl(lat, lng) {
  return `https://maps.google.com/maps?q=${lat},${lng}&z=16&output=embed`;
}

export function mapsDirectionsUrl(lat, lng, query = '') {
  const q = query || `${lat},${lng}`;
  return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(q)}`;
}

export const contactPageContent = {
  title: 'Contact',
  highlight: 'Us',
  subtitle:
    'Reach the FastWhistle team for logistics, fleet SaaS, partnerships, or general enquiries. Visit our Surat office or connect with us by phone, email, or WhatsApp.',
  parentNote: parentCompany.tagline,
  contactMethods: [
    {
      icon: 'WhatsappLogo',
      label: 'WhatsApp',
      value: contact.phone,
      href: `https://wa.me/${contact.phoneRaw}`,
      accent: 'green',
    },
    {
      icon: 'Phone',
      label: 'Phone',
      value: contact.phone,
      href: `tel:${contact.phoneRaw}`,
      accent: 'blue',
    },
    {
      icon: 'Envelope',
      label: 'Email',
      value: contact.email,
      href: `mailto:${contact.email}`,
      accent: 'teal',
    },
  ],
};
